export default class ProductCategory {
    // eslint-disable-next-line no-useless-constructor
    constructor(public id: number, public name: string) {}
}
